export default function ReviewsController(module) {
    angular.module(module)
        .controller('ReviewsController', ReviewsController);

    ReviewsController.$inject = ['$http', '$attrs', '$element', '$timeout'];
    function ReviewsController($http, $attrs, $element, $timeout) {
        var vm = this;
        vm.$onInit = () => {
            var target = $attrs.reviewSource;
            if (target) {
                $http.get('/api/reviews/', {
                    params: {
                        source: target
                    },
                    cache: true
                })
                    .then(response => {
                        vm.data = response.data;
                        $timeout(() => {
                            $element.find('.reviews > div').css('display', '');
                        })
                    })
                    .catch(response => {
                        vm.error = true;
                        $timeout(() => {
                            $element.find('.reviews .error').css('display', '');
                        })
                    });
            }
        }
    }
}